export class ResourceComplianceRow {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "environment",
            "baseName": "environment",
            "type": "Environment",
            "format": ""
        },
        {
            "name": "application",
            "baseName": "application",
            "type": "string",
            "format": ""
        },
        {
            "name": "businessUnit",
            "baseName": "businessUnit",
            "type": "string",
            "format": ""
        },
        {
            "name": "failingControlIds",
            "baseName": "failingControlIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "ResourceType",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "dataClasses",
            "baseName": "dataClasses",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "failureReasons",
            "baseName": "failureReasons",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "backupStatus",
            "baseName": "backupStatus",
            "type": "BackupStatus",
            "format": ""
        },
        {
            "name": "configurationStatus",
            "baseName": "configurationStatus",
            "type": "ConfigurationStatus",
            "format": ""
        },
        {
            "name": "encryptionType",
            "baseName": "encryptionType",
            "type": "EncryptionType",
            "format": ""
        },
        {
            "name": "severityStatus",
            "baseName": "severityStatus",
            "type": "Severity",
            "format": ""
        },
        {
            "name": "networkClassification",
            "baseName": "networkClassification",
            "type": "NetworkClassification",
            "format": ""
        },
        {
            "name": "sensitivityAnnotations",
            "baseName": "sensitivityAnnotations",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceAccountId",
            "baseName": "sourceAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceAccountName",
            "baseName": "sourceAccountName",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceGroup",
            "baseName": "resourceGroup",
            "type": "string",
            "format": ""
        },
        {
            "name": "vpc",
            "baseName": "vpc",
            "type": "string",
            "format": ""
        },
        {
            "name": "clusterName",
            "baseName": "clusterName",
            "type": "string",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "failureOutcomes",
            "baseName": "failureOutcomes",
            "type": "{ [key: string]: RuleOutcomeList; }",
            "format": ""
        },
        {
            "name": "applicableControlIds",
            "baseName": "applicableControlIds",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ResourceComplianceRow.attributeTypeMap;
    }
    constructor() {
    }
}
